// extracted by mini-css-extract-plugin
module.exports = {"switcher":"Switcher_switcher__GzljL"};